var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMammogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2969_41448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: -1,
    width: 54,
    height: 55
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0001,
    cy: 26.5,
    r: 26.8082,
    fill: "#00406A"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2969_41448)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1717 43.3218C38.1717 43.5031 38.0569 43.6495 37.9155 43.6495C37.7741 43.6495 37.6592 43.5031 37.6592 43.3218C37.6592 43.1405 37.7741 42.994 37.9155 42.994C38.0569 42.994 38.1717 43.1405 38.1717 43.3218Z",
    fill: "#FFAA9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0347 19.2769C51.0347 19.2769 53.3167 16.7094 56.0218 18.9627C58.728 21.216 55.8628 26.507 56.0218 28.4462C56.1809 30.3843 57.0145 30.2709 57.3543 32.7327C57.694 35.1954 56.2212 35.7713 57.2158 36.5664C56.0837 36.2018 56.4195 34.602 56.4195 34.602C55.9423 36.96 52.8385 38.6102 54.4694 40.6143C50.8079 39.4353 51.0171 36.5411 50.8217 34.7067C50.5477 32.1364 51.0681 29.3682 51.5551 27.018C52.0422 24.6677 51.0337 19.2769 51.0337 19.2769H51.0347Z",
    fill: "url(#paint0_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6138 33.5664C55.1136 32.9081 54.8641 32.0859 54.6972 31.3451C55.5299 32.0859 55.4474 33.0729 55.2805 34.0599C56.447 32.3322 55.6968 30.4405 54.8641 28.7951C54.6138 28.1368 54.6972 27.397 54.9476 26.8211C56.7612 17.3726 51.5306 19.9778 51.5306 19.9778C51.5306 19.9778 52.0441 24.6676 51.5571 27.0179C51.0701 29.3682 50.5497 32.1363 50.8236 34.7066C51.0082 36.4441 50.8315 39.1347 53.9274 40.4145C53.513 39.8949 53.2862 39.1483 53.1979 38.585C52.9475 36.7748 53.4482 35.1304 54.6138 33.5664Z",
    fill: "#470D1B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6825 20.278C40.5341 21.7043 42.6374 23.8499 42.6374 23.8499L42.6825 20.278Z",
    fill: "url(#paint1_linear_2969_41448)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0706 36.599C52.0823 36.6572 52.0971 36.7154 52.1147 36.7735C52.1 36.7154 52.0853 36.6572 52.0706 36.599Z",
    fill: "#141A73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.636 45.6377C51.5256 40.7229 51.9469 36.5993 50.962 33.8777C50.4073 32.3458 49.9124 31.5555 49.9124 31.5555C49.2957 30.0033 49.497 28.1378 50.853 26.2723C51.1083 25.9213 50.8943 25.1515 50.4181 24.2614C49.8829 25.7788 49.1504 27.2177 48.0772 28.5945C47.1611 29.6629 45.8826 29.2518 44.7083 29.8598C44.9724 30.106 45.5007 31.5303 44.9528 32.7462C44.3901 34.2529 42.9134 36.7593 41.3482 38.5724C39.9549 40.1858 38.7776 40.9314 38.2886 41.8767C36.7666 44.8155 40.381 46.0081 40.381 46.0081C41.2431 46.7391 41.3894 51.4047 40.8641 53.308H50.9611C50.9611 53.308 49.7543 50.5059 50.6351 45.6367L50.636 45.6377Z",
    fill: "url(#paint2_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M43.1205 42.6931C43.1205 43.4823 42.7651 44.1843 42.3212 44.7108C41.6103 45.725 40.1974 45.8365 39.1428 45.3565C39.7614 45.8054 40.382 46.01 40.382 46.01C40.6167 46.2088 40.7983 46.7004 40.9279 47.3471C42.5765 46.6112 43.6017 44.6526 43.1205 42.6931Z",
    fill: "url(#paint3_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M49.5716 26.248C49.1622 27.0518 48.6722 27.8333 48.0781 28.5964C47.162 29.6648 45.8836 29.2537 44.7092 29.8617C44.9704 30.105 45.4898 31.5032 44.9694 32.7112C47.4831 31.6631 48.8892 28.8737 49.5716 26.248Z",
    fill: "url(#paint4_linear_2969_41448)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1901 28.8743C49.2427 27.3851 49.9359 25.8473 50.42 24.2378C49.2643 22.2996 46.8331 19.8408 45.3936 19.7836C43.2815 19.7002 42.7032 21.0392 42.7032 21.0392C41.9893 22.4295 42.7798 23.6309 42.6629 24.39C42.5461 25.1492 40.9888 26.1673 41.1321 26.6133C41.2755 27.0593 41.8067 26.9633 41.8528 27.2939C41.899 27.6236 41.6889 27.6934 41.6692 27.9358C41.6506 28.1782 41.8872 28.3478 41.8872 28.3478C41.8872 28.3478 41.7586 28.5088 41.8882 28.7832C41.9824 28.9819 42.0826 28.9199 42.1602 29.0362C42.2377 29.1536 41.8607 30.5226 42.4655 30.6991C43.0694 30.8746 44.2772 30.7592 44.61 30.6709C45.2051 30.509 47.2877 30.033 48.191 28.8734L48.1901 28.8743Z",
    fill: "url(#paint5_linear_2969_41448)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4704 20.278C41.6643 22.3811 44.5059 23.85 44.5059 23.85C43.8677 22.6797 44.4922 21.8982 44.4922 21.8982C44.6925 23.2246 45.3032 23.6803 46.2056 24.3406C47.1079 25.0008 47.1227 26.1188 47.1227 26.1188C47.1227 26.1188 49.276 26.6617 48.9677 27.2076C48.6594 27.7535 48.0977 29.075 49.5912 29.8196C49.6678 29.235 52.5585 28.7929 53.076 26.174C53.5934 23.5552 53.6631 20.5195 50.7017 18.6346C47.7403 16.7497 43.3482 17.9908 42.4704 20.279V20.278Z",
    fill: "url(#paint6_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9527 19.6807C52.7068 21.5287 52.6891 23.6453 52.1972 25.5863C52.1137 23.2826 51.3645 20.8975 49.5313 19.3345C51.0307 20.9799 51.2811 23.1188 51.1141 25.2577C50.5309 23.366 49.6148 21.3086 47.6981 20.5688C48.8646 21.5558 49.1975 23.7771 47.7815 24.4355C47.4251 24.6245 47.0245 24.7157 46.6052 24.7273C47.1109 25.3633 47.1217 26.1196 47.1217 26.1196C47.1217 26.1196 49.275 26.6626 48.9667 27.2085C48.6584 27.7543 48.0967 29.0759 49.5902 29.8205C49.6668 29.2358 52.5575 28.7937 53.075 26.1749C53.5051 23.9982 53.6239 21.5345 51.9527 19.6816V19.6807Z",
    fill: "#470D1B"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.328 25.4729C47.8935 24.5111 49.2633 25.0521 49.226 26.2001C49.1887 27.3481 48.0418 28.9401 47.2229 28.435C46.405 27.9298 47.327 25.4729 47.327 25.4729H47.328Z",
    fill: "url(#paint7_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M47.65 25.9228C47.9318 25.4971 48.7556 25.5359 48.7664 26.0905C48.7782 26.6451 48.3737 27.5691 48.0958 27.7417C47.8179 27.9153 47.0265 27.7475 47.3122 27.2375C47.5989 26.7275 47.9092 26.9816 47.866 26.5753C47.8238 26.1681 47.4693 26.1943 47.649 25.9228H47.65Z",
    fill: "url(#paint8_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M47.8387 34.1696C44.5719 34.1696 44.5149 40.8209 44.5434 42.7523C44.5709 44.672 44.8213 48.7297 44.7653 50.1007C44.1909 51.0838 43.2483 53.309 43.2483 53.309H49.3528C49.3528 53.309 49.8987 51.844 49.9861 50.1085C50.0794 48.241 51.3657 34.1686 47.8387 34.1686V34.1696Z",
    fill: "url(#paint9_linear_2969_41448)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0566 34.1696C44.7898 34.1696 45.2395 40.8209 45.267 42.7523C45.2945 44.672 45.5449 48.7297 45.4889 50.1007C44.7868 51.047 44.4333 53.309 44.4333 53.309H49.0434C49.0434 53.309 49.7936 51.7189 49.88 49.9834C49.9733 48.116 51.5836 34.1686 48.0556 34.1686L48.0566 34.1696Z",
    fill: "url(#paint10_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M41.9414 27.1136C42.2458 27.1873 42.3921 26.9643 42.3371 26.7122C42.3371 26.7122 42.5531 27.2862 41.9414 27.1136Z",
    fill: "url(#paint11_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M41.8872 28.3492C41.9294 28.3841 42.0404 28.3841 42.0404 28.3841C42.3516 28.5518 42.9211 28.6982 42.9211 28.6982C42.4184 28.5411 42.0767 28.1494 41.9824 28.0292C41.8882 27.909 41.6682 27.9691 41.6682 27.9691C41.6682 27.9691 41.6692 28.1979 41.8872 28.3492Z",
    fill: "url(#paint12_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M41.8874 28.3485C41.8874 28.3485 41.9031 28.3796 42.0406 28.3834C42.0406 28.3834 42.5482 28.621 42.9213 28.6976C42.6916 28.6976 42.235 29.0243 41.9816 28.9109C41.9816 28.9109 41.7155 28.6578 41.8874 28.3485Z",
    fill: "url(#paint13_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M42.1602 29.0373C42.3379 29.076 42.4714 28.9936 42.4714 28.9936C42.3497 29.1362 42.169 29.1575 42.169 29.1575L42.1592 29.0373H42.1602Z",
    fill: "url(#paint14_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M42.8879 28.5554C43.0902 28.7416 42.9213 28.8793 42.9213 28.8793C42.9213 28.8793 42.9773 28.698 42.8879 28.5554Z",
    fill: "url(#paint15_linear_2969_41448)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1379 13.7467H27.8687C29.8198 13.7467 31.4036 15.3106 31.4036 17.2372V53.3083H19.603V17.2372C19.603 15.3106 21.1868 13.7467 23.1379 13.7467Z",
    fill: "#72A0BE"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M27.8932 51.5223C27.1882 51.5223 26.6108 50.9522 26.6108 50.2561V20.9516C26.6108 20.2554 27.1882 19.6853 27.8932 19.6853C28.5982 19.6853 29.1756 20.2554 29.1756 20.9516V50.2561C29.1756 50.9522 28.5982 51.5223 27.8932 51.5223Z",
    fill: "url(#paint16_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4466 20.9517C29.4466 20.2524 28.8724 19.6855 28.1642 19.6855C27.456 19.6855 26.8818 20.2524 26.8818 20.9517V50.2562C26.8818 50.9555 27.456 51.5225 28.1642 51.5225C28.8724 51.5225 29.4466 50.9555 29.4466 50.2562V20.9517Z",
    fill: "#A2BEE4",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M27.1155 50.2562V20.9517C27.1155 20.2943 27.63 19.7504 28.2811 19.6913C28.2428 19.6874 28.2035 19.6855 28.1642 19.6855C27.4592 19.6855 26.8818 20.2556 26.8818 20.9517V50.2562C26.8818 50.9524 27.4592 51.5225 28.1642 51.5225C28.2035 51.5225 28.2428 51.5205 28.2811 51.5167C27.63 51.4575 27.1155 50.9136 27.1155 50.2562Z",
    fill: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.4401 21.3676H28.1593C28.0508 21.3676 27.9629 21.4544 27.9629 21.5615V49.9303C27.9629 50.0374 28.0508 50.1243 28.1593 50.1243H28.4401C28.5486 50.1243 28.6365 50.0374 28.6365 49.9303V21.5615C28.6365 21.4544 28.5486 21.3676 28.4401 21.3676Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3068 13.7468H22.5164V53.3084H23.3068V13.7468Z",
    fill: "#00406A",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2998 45.2937V25.0916C28.2998 24.2364 29.0019 23.5432 29.8679 23.5432H39.794C40.4695 23.5432 41.0174 24.0842 41.0174 24.7512V27.5601C41.0174 28.2272 40.4695 28.7682 39.794 28.7682H36.8453C35.9793 28.7682 35.2772 29.4615 35.2772 30.3166V45.2946H28.3008L28.2998 45.2937Z",
    fill: "#72A0BE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.906 28.7644H38.6668H37.4286L37.0388 29.4072H38.6668H40.2958L39.906 28.7644Z",
    fill: "url(#paint17_linear_2969_41448)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3892 47.7189H30.0309C29.0745 47.7189 28.2998 46.9539 28.2998 46.0096H42.3892V47.7189Z",
    fill: "#72A0BE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.7164 38.5735H35.2771V39.7118H41.7164V38.5735Z",
    fill: "#72A0BE",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M35.7573 38.5735H35.2771V39.7118H35.7573V38.5735Z",
    fill: "url(#paint18_linear_2969_41448)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M30.464 24.262H30.2205C29.5481 24.262 29.0029 24.8002 29.0029 25.4642V42.3455C29.0029 43.0095 29.5481 43.5478 30.2205 43.5478H30.464C31.1364 43.5478 31.6816 43.0095 31.6816 42.3455V25.4642C31.6816 24.8002 31.1364 24.262 30.464 24.262Z",
    fill: "url(#paint19_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M33.9163 44.5516C32.686 42.5562 30.6436 41.2754 28.2998 41.3908V45.2943H35.2762V44.5545L33.9153 44.5516H33.9163Z",
    fill: "url(#paint20_linear_2969_41448)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2998 44.703V41.4733C32.2147 41.4733 33.662 44.6923 33.662 44.6923H36.1747C36.9101 44.6923 37.5061 45.2808 37.5061 46.007H28.3008V44.7039L28.2998 44.703Z",
    fill: "#72A0BE"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M33.5825 44.8256H36.0952C36.7844 44.8256 37.352 45.3433 37.4197 46.0065H37.5061C37.5061 45.2803 36.9101 44.6918 36.1747 44.6918H33.662C33.662 44.6918 32.2147 41.4728 28.2998 41.4728V41.6085C32.1538 41.6522 33.5825 44.8256 33.5825 44.8256Z",
    fill: "url(#paint21_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M30.3422 45.2717C30.7521 45.2717 31.0845 44.9436 31.0845 44.5387C31.0845 44.1339 30.7521 43.8057 30.3422 43.8057C29.9322 43.8057 29.5999 44.1339 29.5999 44.5387C29.5999 44.9436 29.9322 45.2717 30.3422 45.2717Z",
    fill: "url(#paint22_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M36.486 45.7886C36.6536 45.7886 36.7894 45.6545 36.7894 45.489C36.7894 45.3235 36.6536 45.1894 36.486 45.1894C36.3185 45.1894 36.1826 45.3235 36.1826 45.489C36.1826 45.6545 36.3185 45.7886 36.486 45.7886Z",
    fill: "url(#paint23_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M33.34 26.1341C33.7098 25.7892 33.7264 25.2136 33.377 24.8485C33.0277 24.4833 32.4448 24.4669 32.075 24.8119C31.7053 25.1568 31.6887 25.7324 32.038 26.0975C32.3873 26.4626 32.9702 26.479 33.34 26.1341Z",
    fill: "url(#paint24_linear_2969_41448)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7339 25.6016C33.8512 25.1129 33.5451 24.6227 33.0502 24.5068C32.5553 24.3909 32.0589 24.6932 31.9415 25.1819C31.8241 25.6706 32.1302 26.1608 32.6252 26.2767C33.1201 26.3926 33.6165 26.0903 33.7339 25.6016Z",
    fill: "url(#paint25_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M33.5204 25.391C33.5204 25.7633 33.215 26.0649 32.8379 26.0649C32.4609 26.0649 32.1555 25.7633 32.1555 25.391C32.1555 25.0187 32.4609 24.7172 32.8379 24.7172C33.215 24.7172 33.5204 25.0187 33.5204 25.391Z",
    fill: "url(#paint26_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M30.6779 26.4233C30.4344 26.4233 30.2361 26.6182 30.2361 26.8597C30.2361 27.1011 30.4334 27.296 30.6779 27.296C30.9224 27.296 31.1198 27.1011 31.1198 26.8597C31.1198 26.6182 30.9224 26.4233 30.6779 26.4233Z",
    fill: "url(#paint27_linear_2969_41448)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 26.8195C31.1825 27.0609 30.9852 27.2558 30.7407 27.2558C30.4962 27.2558 30.2988 27.0609 30.2988 26.8195C30.2988 26.5781 30.4962 26.3832 30.7407 26.3832C30.9852 26.3832 31.1825 26.5781 31.1825 26.8195Z",
    fill: "url(#paint28_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M31.0678 26.8193C31.0678 26.9977 30.9215 27.1422 30.7408 27.1422C30.5601 27.1422 30.4138 26.9977 30.4138 26.8193C30.4138 26.6409 30.5601 26.4964 30.7408 26.4964C30.9215 26.4964 31.0678 26.6409 31.0678 26.8193Z",
    fill: "url(#paint29_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M30.6779 27.9733C30.4344 27.9733 30.2361 28.1681 30.2361 28.4096C30.2361 28.651 30.4334 28.8459 30.6779 28.8459C30.9224 28.8459 31.1198 28.651 31.1198 28.4096C31.1198 28.1681 30.9224 27.9733 30.6779 27.9733Z",
    fill: "url(#paint30_linear_2969_41448)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 28.3689C31.1825 28.6103 30.9852 28.8052 30.7407 28.8052C30.4962 28.8052 30.2988 28.6103 30.2988 28.3689C30.2988 28.1274 30.4962 27.9325 30.7407 27.9325C30.9852 27.9325 31.1825 28.1274 31.1825 28.3689Z",
    fill: "url(#paint31_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M31.0678 28.3688C31.0678 28.5472 30.9215 28.6916 30.7408 28.6916C30.5601 28.6916 30.4138 28.5472 30.4138 28.3688C30.4138 28.1904 30.5601 28.0459 30.7408 28.0459C30.9215 28.0459 31.0678 28.1904 31.0678 28.3688Z",
    fill: "url(#paint32_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M30.6779 29.5213C30.4344 29.5213 30.2361 29.7162 30.2361 29.9576C30.2361 30.1991 30.4334 30.3939 30.6779 30.3939C30.9224 30.3939 31.1198 30.1991 31.1198 29.9576C31.1198 29.7162 30.9224 29.5213 30.6779 29.5213Z",
    fill: "url(#paint33_linear_2969_41448)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 29.9175C31.1825 30.1589 30.9852 30.3538 30.7407 30.3538C30.4962 30.3538 30.2988 30.1589 30.2988 29.9175C30.2988 29.676 30.4962 29.4812 30.7407 29.4812C30.9852 29.4812 31.1825 29.676 31.1825 29.9175Z",
    fill: "url(#paint34_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M31.0678 29.9175C31.0678 30.0959 30.9215 30.2404 30.7408 30.2404C30.5601 30.2404 30.4138 30.0959 30.4138 29.9175C30.4138 29.7391 30.5601 29.5946 30.7408 29.5946C30.9215 29.5946 31.0678 29.7391 31.0678 29.9175Z",
    fill: "url(#paint35_linear_2969_41448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M30.6779 31.0694C30.4344 31.0694 30.2361 31.2642 30.2361 31.5057C30.2361 31.7471 30.4334 31.942 30.6779 31.942C30.9224 31.942 31.1198 31.7471 31.1198 31.5057C31.1198 31.2642 30.9224 31.0694 30.6779 31.0694Z",
    fill: "url(#paint36_linear_2969_41448)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 31.4652C31.1825 31.7066 30.9852 31.9015 30.7407 31.9015C30.4962 31.9015 30.2988 31.7066 30.2988 31.4652C30.2988 31.2238 30.4962 31.0289 30.7407 31.0289C30.9852 31.0289 31.1825 31.2238 31.1825 31.4652Z",
    fill: "url(#paint37_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M30.7408 31.788C30.9214 31.788 31.0678 31.6434 31.0678 31.4651C31.0678 31.2868 30.9214 31.1423 30.7408 31.1423C30.5602 31.1423 30.4138 31.2868 30.4138 31.4651C30.4138 31.6434 30.5602 31.788 30.7408 31.788Z",
    fill: "url(#paint38_linear_2969_41448)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5967 23.9168H37.8381C37.3234 23.9168 36.9062 24.3287 36.9062 24.8369V27.5023C36.9062 28.0105 37.3234 28.4224 37.8381 28.4224H39.5967C40.1113 28.4224 40.5285 28.0105 40.5285 27.5023V24.8369C40.5285 24.3287 40.1113 23.9168 39.5967 23.9168Z",
    fill: "url(#paint39_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M39.626 27.3955C39.4454 27.3955 39.2991 27.54 39.2991 27.7184C39.2991 27.8968 39.4454 28.0413 39.626 28.0413C39.8067 28.0413 39.953 27.8968 39.953 27.7184C39.953 27.54 39.8067 27.3955 39.626 27.3955Z",
    fill: "url(#paint40_linear_2969_41448)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 27.6889C40.0001 27.8673 39.8538 28.0118 39.6732 28.0118C39.4925 28.0118 39.3462 27.8673 39.3462 27.6889C39.3462 27.5105 39.4925 27.366 39.6732 27.366C39.8538 27.366 40.0001 27.5105 40.0001 27.6889Z",
    fill: "url(#paint41_linear_2969_41448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M39.9147 27.689C39.9147 27.8209 39.8058 27.9285 39.6722 27.9285C39.5387 27.9285 39.4297 27.8209 39.4297 27.689C39.4297 27.5571 39.5387 27.4495 39.6722 27.4495C39.8058 27.4495 39.9147 27.5571 39.9147 27.689Z",
    fill: "url(#paint42_linear_2969_41448)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1939 48.3527H41.9031V47.7186H36.5518C36.5518 48.0687 36.8395 48.3527 37.1939 48.3527Z",
    fill: "#A2BEE4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M40.11 29.4092L41.9599 38.785H35.2771L37.1771 29.3927L40.11 29.4092Z",
    fill: "url(#paint43_linear_2969_41448)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2969_41448",
    x1: 50.6096,
    y1: 44.4917,
    x2: 54.0272,
    y2: 27.9702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#722F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#612139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2969_41448",
    x1: 41.8047,
    y1: 23.7287,
    x2: 42.2732,
    y2: 22.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#722F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#612139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2969_41448",
    x1: 43.7136,
    y1: 50.2199,
    x2: 51.1099,
    y2: 27.8082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2969_41448",
    x1: 40.6108,
    y1: 46.5695,
    x2: 41.846,
    y2: 42.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2969_41448",
    x1: 45.8286,
    y1: 31.9957,
    x2: 47.6618,
    y2: 26.4397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2969_41448",
    x1: 42.3083,
    y1: 24.1024,
    x2: 46.937,
    y2: 27.0161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2969_41448",
    x1: 46.0514,
    y1: 13.2835,
    x2: 48.3275,
    y2: 24.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#722F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#612139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2969_41448",
    x1: 49.2002,
    y1: 26.3153,
    x2: 47.5496,
    y2: 26.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFD0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFC7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FFB6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2969_41448",
    x1: 47.2188,
    y1: 26.7589,
    x2: 48.7959,
    y2: 26.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2969_41448",
    x1: 45.1502,
    y1: 51.3437,
    x2: 49.9099,
    y2: 36.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2969_41448",
    x1: 45.3092,
    y1: 51.0451,
    x2: 49.996,
    y2: 36.8449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2969_41448",
    x1: 42.1538,
    y1: 26.9238,
    x2: 42.2819,
    y2: 27.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2969_41448",
    x1: 41.8283,
    y1: 28.1126,
    x2: 42.5606,
    y2: 28.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2969_41448",
    x1: 41.9807,
    y1: 28.4843,
    x2: 42.5124,
    y2: 28.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2969_41448",
    x1: 42.221,
    y1: 29.0091,
    x2: 42.3379,
    y2: 29.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2969_41448",
    x1: 42.8879,
    y1: 28.7174,
    x2: 42.9871,
    y2: 28.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2969_41448",
    x1: 27.8932,
    y1: 12.1653,
    x2: 27.8932,
    y2: 56.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2F3FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#162871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2969_41448",
    x1: 41.913,
    y1: 29.0853,
    x2: 32.2943,
    y2: 29.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2F3FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#162871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2969_41448",
    x1: 35.7199,
    y1: 39.1426,
    x2: 35.1946,
    y2: 39.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2F3FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#162871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2969_41448",
    x1: 26.5167,
    y1: 33.9054,
    x2: 31.2201,
    y2: 33.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A3D9FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A3D9FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A3D9FF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A3D9FF",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A3D9FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2969_41448",
    x1: 34.6488,
    y1: 43.3387,
    x2: 27.6606,
    y2: 43.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2F3FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#162871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2969_41448",
    x1: 29.6637,
    y1: 47.2224,
    x2: 35.0154,
    y2: 41.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#475BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6C8ED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2969_41448",
    x1: 29.2591,
    y1: 45.264,
    x2: 30.6705,
    y2: 44.2953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2969_41448",
    x1: 36.0442,
    y1: 45.7857,
    x2: 36.6198,
    y2: 45.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2969_41448",
    x1: 31.3626,
    y1: 26.3745,
    x2: 33.1139,
    y2: 25.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2969_41448",
    x1: 31.494,
    y1: 26.2906,
    x2: 33.2454,
    y2: 25.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2969_41448",
    x1: 31.8413,
    y1: 26.0571,
    x2: 33.1397,
    y2: 25.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2969_41448",
    x1: 30.0338,
    y1: 27.2911,
    x2: 30.8734,
    y2: 26.7141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2969_41448",
    x1: 30.0956,
    y1: 27.251,
    x2: 30.9362,
    y2: 26.6739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2969_41448",
    x1: 30.2626,
    y1: 27.1393,
    x2: 30.885,
    y2: 26.7112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2969_41448",
    x1: 30.0338,
    y1: 28.841,
    x2: 30.8734,
    y2: 28.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2969_41448",
    x1: 30.0956,
    y1: 28.8003,
    x2: 30.9362,
    y2: 28.2233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2969_41448",
    x1: 30.2626,
    y1: 28.6887,
    x2: 30.885,
    y2: 28.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2969_41448",
    x1: 30.0328,
    y1: 30.3891,
    x2: 30.8734,
    y2: 29.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2969_41448",
    x1: 19.6029,
    y1: 30.3489,
    x2: 30.9422,
    y2: 29.7673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2969_41448",
    x1: 30.2626,
    y1: 30.2365,
    x2: 30.885,
    y2: 29.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2969_41448",
    x1: 30.0328,
    y1: 31.9371,
    x2: 30.8734,
    y2: 31.3601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2969_41448",
    x1: 19.6029,
    y1: 31.8967,
    x2: 19.6987,
    y2: 31.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2969_41448",
    x1: 30.2626,
    y1: 31.7851,
    x2: 30.885,
    y2: 31.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2969_41448",
    x1: 43.3299,
    y1: 26.1691,
    x2: 38.5225,
    y2: 26.1691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A3D9FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A3D9FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A3D9FF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A3D9FF",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A3D9FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2969_41448",
    x1: 39.1488,
    y1: 28.0383,
    x2: 39.7713,
    y2: 27.6112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3545B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2C3C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14276D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2969_41448",
    x1: 39.195,
    y1: 28.0079,
    x2: 39.8174,
    y2: 27.5808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2969_41448",
    x1: 39.3187,
    y1: 27.9256,
    x2: 39.7804,
    y2: 27.6089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3948B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2969_41448",
    x1: 38.6185,
    y1: 30.1005,
    x2: 38.6185,
    y2: 39.0982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A3D9FF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A3D9FF",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A3D9FF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A3D9FF",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A3D9FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D9FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMammogram);
export default __webpack_public_path__ + "static/media/mammogram.bf0397d77e69beb9bde6dc65458ea43b.svg";
export { ForwardRef as ReactComponent };